module.exports = __webpack_public_path__ + "static/assets/2818617776418c78a13966e88af8be50.png";